// extracted by mini-css-extract-plugin
export default {"header":"MyHeader_header__phep2","logo":"MyHeader_logo__0NHPU"};